/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of resending an invitation
 * @export
 * @interface ResendInvitation200Response
 */
export interface ResendInvitation200Response {
    /**
     * 
     * @type {number}
     * @memberof ResendInvitation200Response
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ResendInvitation200Response
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ResendInvitation200Response
     */
    role: ResendInvitation200ResponseRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof ResendInvitation200Response
     */
    invitedById: number;
    /**
     * 
     * @type {Date}
     * @memberof ResendInvitation200Response
     */
    expiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ResendInvitation200Response
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ResendInvitation200Response
     */
    message: string;
}


/**
 * @export
 */
export const ResendInvitation200ResponseRoleEnum = {
    Admin: 'admin',
    Member: 'member'
} as const;
export type ResendInvitation200ResponseRoleEnum = typeof ResendInvitation200ResponseRoleEnum[keyof typeof ResendInvitation200ResponseRoleEnum];


/**
 * Check if a given object implements the ResendInvitation200Response interface.
 */
export function instanceOfResendInvitation200Response(value: object): value is ResendInvitation200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('invitedById' in value) || value['invitedById'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ResendInvitation200ResponseFromJSON(json: any): ResendInvitation200Response {
    return ResendInvitation200ResponseFromJSONTyped(json, false);
}

export function ResendInvitation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendInvitation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'role': json['role'],
        'invitedById': json['invitedById'],
        'expiresAt': (new Date(json['expiresAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'message': json['message'],
    };
}

export function ResendInvitation200ResponseToJSON(json: any): ResendInvitation200Response {
    return ResendInvitation200ResponseToJSONTyped(json, false);
}

export function ResendInvitation200ResponseToJSONTyped(value?: ResendInvitation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'role': value['role'],
        'invitedById': value['invitedById'],
        'expiresAt': ((value['expiresAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'message': value['message'],
    };
}

